import React, { useState, useEffect, useContext } from 'react'

import LineChart from './LineChart'
import { datePaddingDays, getTodayDate } from './Common'
import { appserverURL } from './Common'
// import './styles/SeasonalBarChart.css'
import './styles/StockLineChart.css'
import { UserContext } from './UserContext'
import Tippy from '@tippyjs/react'

import { BsFillCaretUpFill, BsFillCaretDownFill, BsQuestionCircle, BsFillCaretLeftFill,BsFillCaretRightFill } from "react-icons/bs";

import { BiExport } from 'react-icons/bi'
import { getCookie, setCookie } from './Common'
import { getSelectedIDFromSecuritiesList2 } from './Common'
import { UIcolors } from './Common'
import { BsDownload, BsPencilSquare } from 'react-icons/bs';
import { opp_dashboard_dialog_content } from './Common'
import { BsFillCircleFill } from "react-icons/bs"


const StockLineChart = (props) => {

    // find if year is leap
    const isLeap = year => new Date(year, 1, 29).getDate() === 29;

    const { browserH, browserW, rdd, token, infoTextSize, loggedinUser } = useContext(UserContext)

    const [lineChartMsg, SetLineChartMsg] = useState('Price Chart') // message shown when no linechart data

    const [lineChartData, SetLineChartData] = useState([])
    // const [linePointStyle, SetLinePointStyle] = useState([])

    const [lineChartDate0, SetLineChartDate0] = useState('') // lineChartDate0 and 1 is used for the text display of linechart
    const [lineChartDate1, SetLineChartDate1] = useState('')
    const [statDisplay, SetStatDisplay] = useState(() => {

        var disp = getCookie('statdisplay')
        if (disp == null) {

            disp = 'none'; //initial condition before there is a cookie
            setCookie('statdisplay', disp, 300);
        }

        if (props.symbol === '') disp = 'none';

        return disp;
    })

    const [showCurrentLineChart, SetShowCurrentLineChart] = useState(true)  // set to true when showing current inactive linechart
    const [headerTooltip, SetHeaderTooltip] = useState('Date Range for the displayed Trade')

    // otherwise false.  used to change the linechart heading text

    var questionSize = 16;
    if (rdd.isTablet && browserH > browserW) {
        if (browserH > 1024) questionSize = 30;
        else questionSize = 22;
    }


    // find the index number from the value of the selected security.  want to just pass the index number to flask
    // const getSelectedIDFromSecuritiesList = () => {
    //     for (var i = 0; i < props.securityTypeList.length; i++) {
    //         if (props.securityTypeList[i]['value'] === props.selectedSecurity) break
    //     }

    //     return (i)
    // }

    // turn off stat display when seasonal viewer is blank with no stock displayed
    useEffect(() => {
        if (props.symbol === '') SetStatDisplay('none')
    }, [props.symbol])


    useEffect(() => { //fetch linechart data

        // calculate the date range to download daily stock data from the server


        // console.log('linechart fetch')

        // console.log('props.lineChartYear=',props.lineChartYear)
        // console.log('props.barChartLongOrShort=',props.barChartLongOrShort)
        // console.log('props.startDate=',props.startDate)
        // console.log('props.symbol=',props.symbol)
        // console.log('props.daysOut=',props.daysOut)
        // console.log('props.seasonalYears=',props.seasonalYears)
        // console.log('token=',token)
        // console.log('\n\n\n')



        var d = props.startDate
        var daysOut = parseInt(props.daysOut)

        // daysOut need to be decremented by 1 since we did the cosmetic incremting of daysOut so the months daysOut was the same as the number of the months
        daysOut--;

        // if leap day feb 29th is inside the date-range, increment daysOut by 1 because we are ignoring existance of feb 29th

        var ds = d.split('-')
        var dd = ds[1] + '/' + ds[2] + '/' + props.lineChartYear //same date in mm/dd/yyyy format - wrote before I knew how to do it easier


        //for padded dates
        var date0 = new Date(dd);
        var date1 = new Date(dd);
        //original dates  
        var dateo0 = new Date(dd);
        var dateo1 = new Date(dd);




        dateo0.setDate(dateo0.getDate());
        dateo1.setDate(dateo1.getDate() + daysOut);

        // check if dateo0 to dateo1 range contains a feb29th.  if it does, advance the dateo1 by 1 day 12/6/2021

        var isExitYearLeap = isLeap(dateo1.getFullYear())
        let feb29 = new Date(dateo1.getFullYear(), 1, 29);
        if (isExitYearLeap && dateo1 > feb29 && dateo0 < feb29) {
            dateo1.setDate(dateo1.getDate() + 1);
        }


        var do0 = dateo0.getFullYear() + '-' + (dateo0.getMonth() + 1 < 10 ? '0' : '') + (dateo0.getMonth() + 1) + '-' + (dateo0.getDate() < 10 ? '0' : '') + dateo0.getDate() //original dates in yyyy-mm-dd formats
        var do1 = dateo1.getFullYear() + '-' + (dateo1.getMonth() + 1 < 10 ? '0' : '') + (dateo1.getMonth() + 1) + '-' + (dateo1.getDate() < 10 ? '0' : '') + dateo1.getDate()


        date0.setDate(date0.getDate() - datePaddingDays);
        date1.setDate(date1.getDate() + daysOut + datePaddingDays);


        let mm0 = String(date0.getMonth() + 1).padStart(2, '0');
        let mm1 = String(date1.getMonth() + 1).padStart(2, '0');
        let dd0 = String(date0.getDate() + 1).padStart(2, '0');
        let dd1 = String(date1.getDate() + 1).padStart(2, '0');

        var d0 = date0.getFullYear() + '-' + mm0 + '-' + dd0 //padded dates in yyyy-mm-dd formats
        var d1 = date1.getFullYear() + '-' + mm1 + '-' + dd1

        let td = getTodayDate();
        if (d1 > td) {

            d1 = td;

            if (daysOut < 100) date0.setDate(date0.getDate() - 100); // add at least 100 days to show the stock history until today
            else date0.setDate(date0.getDate() - daysOut);
            mm0 = String(date0.getMonth() + 1).padStart(2, '0');
            mm1 = String(date1.getMonth() + 1).padStart(2, '0');
            d0 = date0.getFullYear() + '-' + mm0 + '-' + dd0 //padded dates in yyyy-mm-dd formats
        }

        props.SetTradeDate0(do0)
        props.SetTradeDate1(do1)  // should be maximum at last linechart bar

        // var id = getSelectedIDFromSecuritiesList()
        var id = getSelectedIDFromSecuritiesList2(props.securityTypeList, props.selectedSecurity)
        let asURL = appserverURL()
        var url = `${asURL}/ChartHistorical2/${id}/${props.symbol}/${d0}/${d1}?token=${token}`

        // console.log('charthistorical 2 url=',url)
        // if (token && token.length > 0) {
        // # if (token  is added due to occational crash caused race condition
        if (token && token.length > 0 && props.lineChartYear !== 0) {
            fetch(url)
                .then(res => {
                    const contentType = res.headers.get("content-type");

                    if (contentType && contentType.indexOf("application/json") !== -1) {
                        return res.json();
                    }
                    else if (res.status === 429) { // too many requests
                        let trigger = res.headers.get("trigger");
                        // console.log('trigger=', trigger)
                        // props.SetDialogType('info-box'); //429
                        props.SetDialogType('rate-limit'); //429
                        // props.SetDialogProp({ title: 'Too Many Requests', contentText: ratelimitMessage(trigger, loggedinUser), button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' })
                        props.SetInfoBoxVisible(true)

                    }
                    else {
                        console.log('response status = ', res.status)
                    }
                })
                .then((t) => {
                    if (t !== undefined) {
                        SetLineChartData(t['ChartHistorical2'])

                        // console.log('fetch line chart')
                        // console.log('charthistorical2=', t)
                        // console.log('length=', t['ChartHistorical2'].length)
                        // console.log("t['ChartHistorical2']=", t['ChartHistorical2'])

                        if (t['ChartHistorical2'].length > 0) {

                            var stock_price = parseFloat(t['ChartHistorical2'][t['ChartHistorical2'].length - 1][1])
                            var price_date = t['ChartHistorical2'][t['ChartHistorical2'].length - 1][0]


                            if (price_date > props.lastPrice[0]) {
                                // props.SetLastPrice([price_date,stock_price])
                            }

                        }
                        else {
                            // props.SetLastPrice(['',-1])
                        }



                        if (t['ChartHistorical2'].length > 0) {

                            // tmp = JSON.parse(JSON.stringify(t['ChartHistorical2'])); //making a clone / copy 
                            // console.log(,t['ChartHistorical2'][t['ChartHistorical2'].length-1][0])

                            SetLineChartDate0(t['ChartHistorical2'][0][0])
                            SetLineChartDate1(t['ChartHistorical2'][t['ChartHistorical2'].length - 1][0])


                            let lastDate = t['ChartHistorical2'][t['ChartHistorical2'].length - 1][0]; // last date in displayed linechart 5/26/2022


                            var tmpDates = t['ChartHistorical2'].map((r) => { //create array of only the dates in the dataset
                                return r[0]
                            })


                            // console.log('tmpDates = ',tmpDates)
                            // console.log('lastDate=',tmpDates[tmpDates.length-1])

                            var includesTradeDate1 = do1 < tmpDates[tmpDates.length - 1]

                            var isActive = false;
                            if (!includesTradeDate1) isActive = true;
                            if (props.startDate > lastDate) isActive = false; //5/26/2022 - override Active if startDate is > last date in linechart

                            // if (props.seasonalBarChartData[props.seasonalBarChartData.length-1]['pct']=='0,0,0')isActive = false;

                            props.SetTradeActive(isActive) //true if the latest trade is active
                        }
                        else { // no current data for this ticker
                            SetLineChartData([])
                            SetLineChartMsg('Not Traded')
                            // props.SetLastPrice(['',-1])
                        }
                    }
                })
        }
        else {  // if linechartyear is 0 then clearthe chart
            SetLineChartData([])
            SetLineChartMsg('Price Chart')
        }


        if (props.seasonalBarChartData.length > 0) {

            // let tmp2 = props.seasonalBarChartData[props.seasonalYears];
            let tmp2 = props.seasonalBarChartData[props.seasonalBarChartData.length - 1];

            // check if linechart shown is the current inactive linechart
            if (tmp2['pct'] === '0,0,0' && tmp2['year'] === props.lineChartYear) {
                SetShowCurrentLineChart(true)
                SetHeaderTooltip('This is the up-to-date daily price chart until the last available date.  There is no active trade for this chart yet.')
            }
            else {
                SetShowCurrentLineChart(false)
                SetHeaderTooltip('Date Range for the displayed Trade')
            }
        }

    }, [props.lineChartYear, props.startDate, props.symbol, props.daysOut, props.seasonalYears, token])


    // dynamic styles

    var linechartDescFontSize = '0.85vw';


    if (rdd.isMobile && !rdd.isTablet && browserH > browserW) { linechartDescFontSize = '2.9vw'; }
    else if (rdd.isMobile && !rdd.isTablet && browserH < browserW) { linechartDescFontSize = '1.7vw'; }
    else if (rdd.isMobile && rdd.isTablet && browserH > browserW) { linechartDescFontSize = '1.9vw'; }
    else if (rdd.isMobile && rdd.isTablet && browserH < browserW) { linechartDescFontSize = '1.9vw'; }




    const linechartDescStyle = {
        fontSize: linechartDescFontSize,
        backgroundColor: "transparent",
        color: "white",
        // flexGrow: "2",
        // alignItems: "center",
        // justifyContent: "center",
        textAlign: "center",
    }
    let linechartControlsHeight = '8%'
    let linechartHeight = '92%'

    if (rdd.isMobile) {
        if (rdd.isTablet) {
            if (browserH > browserW) {
                linechartControlsHeight = '12%'
                linechartHeight = '88%'
            }
        }
        else {
            linechartControlsHeight = '12%'
            linechartHeight = '88%'
        }

    }


    const linechartControlsStyle = {
        // backgroundColor:"red",
        height: linechartControlsHeight,
        display: "flex",
        justifyContent: props.seasonalBarChartData.length > 0 ? 'center' : 'left'

    }

    const linechartStyle = {
        height: linechartHeight,
        backgroundColor: UIcolors(props.loggedinUser)['background_price_chart'],
        borderLeft: '1px solid lightgray'
    }

    const StyleBackArrow = {
        display: 'none'
    }

    const boldYear = {
        // fontWeight: 'bold', //bold doesn't seem to work on react.  maybe after upgrade to new ver it will work
        // as a work around I increasd the size of the font.
        fontSize: '1.1vw',
        fontSize: boldYearSize,
        backgroundColor: 'transparent'
    }

    const handleBackClick = () => {
        if (rdd.isMobile && browserH > browserW) {
            props.chartTo(0)
        }
        else if (rdd.isMobile && !rdd.isTablet && browserH < browserW) {
            props.chartTo(1)
        }
    }


    //---------------------------------------------------------------------------------------------

    useEffect(() => {
        // console.log('lineChartData=', props.lineChartYear, lineChartData[lineChartData.length - 1])
    }, [props.lineChartYear])

    //---------------------------------------------------------------------------------------------

    useEffect(() => {
        SetStatDisplay(statDisplay); // stores state of floating window on linechart (trade stat)
    }, [statDisplay])

    //---------------------------------------------------------------------------------------------

    const saveStatDisplay = (display) => {
        setCookie('statdisplay', display, 300)
    }


    const handleStatTurnOn = (event) => {

        if (statDisplay === 'none') {
            SetStatDisplay('inline');
            saveStatDisplay('inline')
            // setCookie('statdisplay', 'inline', 300)
            // console.log('statDisplay=inline')

        }
        else {
            SetStatDisplay('none');
            saveStatDisplay('none')
            // setCookie('statdisplay', 'none', 300);
            // console.log('statDisplay=none')
        }
    }

    const handleHelpClicked = () => {
        // props.SetHelpBoxVisible(!props.helpBoxVisible);
        props.SetVideosBoxVisible(true)
    }


    var questionDisplay = "flex";
    var caretSize = '4vw';
    var dispSecurity = 'inline';
    var svFont = '7vw';
    var boldYearSize = '1.1vw';
    var pencil_icon_size = 20;
    var download_icon_size = 20;

    if (rdd.isMobile && !rdd.isTablet && window.innerHeight > window.innerWidth) { // smartphone portrait
        caretSize = '5vw';
        dispSecurity = 'none';
        svFont = '10vw';
        boldYearSize = '5vw'
    }
    else if (rdd.isMobile && !rdd.isTablet && window.innerHeight < window.innerWidth) { //smartphone landscape
        caretSize = '4vw';
        // questionDisplay = "none";
    }
    else if (rdd.isMobile && rdd.isTablet && window.innerHeight > window.innerWidth) { // tablet portrait
        caretSize = '4vw';
    }
    else if (rdd.isMobile && rdd.isTablet && window.innerHeight < window.innerWidth) { //tablet landscape
        caretSize = '2.0vw';
        questionDisplay = "none";
    }
    else if (!rdd.isMobile) {                                       // desktop
        caretSize = '1.2vw';
        questionDisplay = "none";
    }
    //-------------------------------------------------------------------------------------------------
    const handleExport = () => {
        props.SetShowWatermark(true);
        props.SetExportImage(true)
    }
    //------------------------------------------------------------------------------------------
    const handleDRreport = () => {

        if (loggedinUser === '0') {
            props.SetDialogType('info-box');
            props.SetDialogProp({ title: 'Portfolio Manager', contentText: opp_dashboard_dialog_content, button1Text: '', button2Text: 'Close', coverDivColor: 'rgb(222,222,222,0)' });
            props.SetInfoBoxVisible(true);
        }

        else {
            props.SetReportsDashVisible(true);
        }

    }

    //------------------------------------------------------------------------------------------
    const handle3Circles = (num) => {

    }
    //-------------------------------------------------------------------------------------------------
    return (
        <div className="linechart-parent">

            <div className="linechart-controls" style={linechartControlsStyle}  >

                <div style={{ backgroundColor: 'transparent', width: '20%', display: 'flex', alignItems: 'center' }}>

                    {(!rdd.isMobile || (rdd.isMobile && rdd.isTablet && browserW > browserH)) &&

                        <Tippy placement={'bottom'} content={
                            <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                                {props.tooltipSW ? 'Portfolio Manager' : ''}
                            </div>
                        }>
                            <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'left' }} >
                                <BsPencilSquare size={pencil_icon_size} style={{ fill: "white", marginLeft: '10px' }} onClick={handleDRreport} />
                            </div>
                        </Tippy>
                    }

                    {((!rdd.isMobile && props.symbol !== '') || (rdd.isMobile && rdd.isTablet && browserH < browserW && props.symbol !== ''))
                        ?


                        <Tippy placement={'bottom'} content={
                            <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                                {props.tooltipSW ? 'Export Strategy Barchart and Price Chart as Jpeg' : ''}
                            </div>
                        }>
                            <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'left', paddingLeft: '10px' }} >
                                <BsDownload size={download_icon_size} style={{ fill: "white" }} onClick={handleExport} />
                            </div>
                        </Tippy>
                        :
                        <div style={{ height: '100%', width: '10%', display: 'flex', alignItems: 'center', justifyContent: 'left', paddingLeft: '10px' }} >
                        </div>
                    }


                    {props.symbol !== '' &&
                        <Tippy placement={'bottom'} content={
                            <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                                {props.tooltipSW ? 'toggle switch to show or hide the trade detail window ' : ''}
                            </div>
                        }>

                            {showCurrentLineChart
                                ?
                                <div className='linechart-desc-left'  ></div>
                                :
                                <div className='linechart-desc-left' onClick={handleStatTurnOn} >
                                    {statDisplay === 'none'
                                        ? <BsFillCaretDownFill size={caretSize} style={{ fill: "white" }} />
                                        : <BsFillCaretUpFill size={caretSize} style={{ fill: "white" }} />
                                    }
                                </div>
                            }

                        </Tippy>
                    }
                </div>


                <div style={{ backgroundColor: 'transparent', width: "90%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                    {/* description on the top control bar */}
                    {props.symbol !== '' ?
                        <div className='linechart-desc' style={linechartDescStyle} >

                            <Tippy placement={'bottom'} content={
                                <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                                    {props.tooltipSW ? 'Name of the security' : ''}
                                </div>
                            }>
                                <span style={{ color: UIcolors(loggedinUser)['security_name'], display: dispSecurity }}>&nbsp;
                                    <strong>{props.allowedSymbols[props.symbol]}</strong>
                                </span>
                            </Tippy>
                            <span style={{ color: "white" }}>
                                &nbsp;
                            </span>

                            {/* tradedate0 to tradedate1 displayed on control bar of stocklinechart */}

                            <Tippy placement={'bottom'} content={
                                <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                                    {props.tooltipSW ? headerTooltip : ''}
                                </div>
                            }>
                                {showCurrentLineChart
                                    ? <span>Current Price Chart</span>
                                    : <span>
                                        <span style={boldYear} >Price Chart {props.tradeDate0.substring(0, 4)}</span>
                                        <span>{props.tradeDate0.substring(4)}  </span>
                                        <span>   to   </span>
                                        <span style={boldYear}  >{props.tradeDate1.substring(0, 4)}</span>
                                        <span>{props.tradeDate1.substring(4)}</span>

                                    </span>
                                }
                            </Tippy>

                            <span style={{ color: 'red', fontSize: linechartDescFontSize, paddingLeft: '10px' }}>
                                {props.tradeActive ? "ACTIVE" : ""}
                            </span>
                        </div>
                        :
                        <div className='linechart-desc' style={linechartDescStyle} ></div>
                    }

                </div>




                {/* right spacing div to match the left divs to center the text in the middle */}
                {
                    (!rdd.isMobile || (rdd.isMobile && rdd.isTablet && browserH < browserW))
                        ?
                        <div style={{ width: '20%', backgroundColor: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>


                            <Tippy placement={'top'} content={
                                <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                                    {'Trend Chart'}

                                </div>
                            }>


                                <div style={{ marginLeft: '1vw', display: 'flex', alignItems: 'center', width: '20%' }}> <BsFillCircleFill size={12} style={{ fill: "white" }} onClick={() => props.chartTo(0)} /></div>
                            </Tippy>




                            <Tippy placement={'top'} content={
                                <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                                    {'Wave Stats'}
                                </div>
                            }>


                                <div style={{ marginLeft: '1vw', display: 'flex', alignItems: 'center', width: '20%' }}> <BsFillCircleFill size={12} style={{ fill: "white" }} onClick={() => props.chartTo(1)} /></div>
                            </Tippy>


                            <Tippy placement={'top'} content={
                                <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                                    {'Price Chart'}
                                </div>
                            }>

                                <div style={{ marginLeft: '1vw', display: 'flex', alignItems: 'center', width: '20%' }}> <BsFillCircleFill size={12} style={{ fill: "red" }} /></div>
                            </Tippy>


                        </div>
                        : rdd.isMobile && rdd.isTable && browserH < browserW ?
                            <div style={{ width: '20%', backgroundColor: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'right', paddingRight: '2vw' }}>
                                <BsQuestionCircle size={questionSize} style={{ fill: "white" }} onClick={handleHelpClicked} />
                            </div>
                            : <div style={{ width: '20%', backgroundColor: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'right', paddingRight: '2vw' }}>
                            </div>
                }




            </div>

            <div className="linechart" style={linechartStyle}>
                {
                    // props.seasonalBarChartData.length > 0
                    lineChartData.length > 0
                        ? <LineChart showCurrentLineChart={showCurrentLineChart} statDisplay={statDisplay} SetStatDisplay={SetStatDisplay} lineChartData={lineChartData} barChartLongOrShort={props.barChartLongOrShort} tradeDate0={props.tradeDate0} tradeDate1={props.tradeDate1} activeTrade={props.tradeActive} saveStatDisplay={saveStatDisplay} statBoxCoordinates={props.statBoxCoordinates} SetStatBoxCoordinates={props.SetStatBoxCoordinates} />
                        : <div className='barchart-background'><span style={{ fontSize: svFont, color: 'rgb(153, 196, 210)' }} >{lineChartMsg}</span></div>
                }
            </div>

            {/* statBoxCoordinates={props.statBoxCoordinates} SetStatBoxCoordinates={props.SetStatBoxCoordinates} */}
        </div>
    )
}

export default StockLineChart
